export default {
  // —— Console OpenAPI ——
  'pages.openapi.overview.title': '开放平台概览',
  'pages.openapi.overview.loadFailed': '加载用量概览失败（接口可能尚未就绪）',
  'pages.openapi.overview.docsTitle': '接入文档',
  'pages.openapi.overview.docsDesc':
    '开放平台 BasePath 为 /v1，响应信封为 {code,message,data,request_id}；使用 API Key 时在 Authorization 头携带 Bearer sk_live_...。密钥明文仅在创建或轮换时展示一次，请妥善保存。',
  'pages.openapi.overview.docsLink': '查看开发者文档',
  'pages.openapi.overview.level': '当前等级',
  'pages.openapi.overview.qps': 'QPS 上限',
  'pages.openapi.overview.apps': '应用数',
  'pages.openapi.overview.appsSuffix': '（上限 {maxApps}，每应用 Key {maxKeys}）',
  'pages.openapi.overview.dailyUsage': '今日用量',

  'pages.openapi.identity.title': '身份与权益速查',
  'pages.openapi.identity.myStatus': '我的身份',
  'pages.openapi.identity.owned': '已具备',
  'pages.openapi.identity.how': '怎么拿',
  'pages.openapi.identity.notWhat': '不是',
  'pages.openapi.identity.goGithub': '去开发者认证',
  'pages.openapi.identity.goEnterprise': '企业认证申请',
  'pages.openapi.identity.tag.user': '普通用户',
  'pages.openapi.identity.tag.commercial': '已绑商业机',
  'pages.openapi.identity.tag.noCommercial': '未绑商业机',
  'pages.openapi.identity.tag.github': 'GitHub 开发者',
  'pages.openapi.identity.tag.noGithub': '未 GitHub 认证',
  'pages.openapi.identity.tag.enterprise': '企业开发者',
  'pages.openapi.identity.tag.noEnterprise': '未企业认证',
  'pages.openapi.identity.conceptTip':
    '口语里的「商业认证」若指 B2B 开通 → 对应「企业认证」；若指设备能力 → 对应「自绑商业授权设备」。企业认证与 GitHub 互不强制、可叠加。',
  'pages.openapi.identity.conceptsTitle': '三个易混概念',
  'pages.openapi.identity.concept.github': 'GitHub 认证',
  'pages.openapi.identity.concept.githubWhat': '个人开发者身份',
  'pages.openapi.identity.concept.githubHow': '控制台「开发者认证」绑定 GitHub',
  'pages.openapi.identity.concept.githubNot': '不是登录方式；不替代平台账号',
  'pages.openapi.identity.concept.enterprise': '企业认证',
  'pages.openapi.identity.concept.enterpriseWhat': 'B2B 企业开发者身份',
  'pages.openapi.identity.concept.enterpriseHow': '申请审核通过，或管理员开通 Tenant',
  'pages.openapi.identity.concept.enterpriseNot': '不强制先做 GitHub',
  'pages.openapi.identity.concept.commercial': '自绑商业授权设备',
  'pages.openapi.identity.concept.commercialWhat': '设备侧权益（子态）',
  'pages.openapi.identity.concept.commercialHow': '绑定带有效 License 的商业机',
  'pages.openapi.identity.concept.commercialNot': '不是「认证」身份；与 GitHub / 企业独立',
  'pages.openapi.identity.githubCompareTitle': '未 GitHub 认证 vs 已认证',
  'pages.openapi.identity.githubCompareHint':
    'GitHub 主要解锁个人开发者能力（OpenAPI、内测、开源机额度、KB 2→5）。不能单独打开知识库——KB 仍要求先有自绑商业机。',
  'pages.openapi.identity.enterpriseCompareTitle': 'GitHub 认证后 vs 企业认证',
  'pages.openapi.identity.enterpriseCompareHint': '企业解决 B2B 产线与租户；与 GitHub 互补，不互相替代。',
  'pages.openapi.identity.relationTitle': '联系与叠加',
  'pages.openapi.identity.relationTree':
    '普通用户\n  ├─ 绑商业授权设备  → 该机可用商业模型；KB 上限 2\n  ├─ GitHub 认证     → OpenAPI L1、内测能力、开源机 100、KB 上限 5（仍要商业机）\n  └─ 企业认证        → Tenant / 产线 / License、OpenAPI L4/L5、KB 按合同\n         ↑ 与 GitHub 独立，可同时拥有',
  'pages.openapi.identity.relationComplement':
    '互补：商业机解决「能不能用 KB / 商业模型」；GitHub 解决「开发者工具与配额升档」；企业解决「B2B 产线与租户」。',
  'pages.openapi.identity.relationKb': 'KB 优先级：企业合同上限 ＞ GitHub 的 5 ＞ 普通有商业机的 2 ＞ 0。',
  'pages.openapi.identity.relationHard': '硬约束：开源设备不可启用业务 KB；Tenant 无租户级知识库。',
  'pages.openapi.identity.relationUnbind': '解绑 GitHub 收回个人开发者增量；若已是企业开发者，企业身份与能力保留。',
  'pages.openapi.identity.col.capability': '能力',
  'pages.openapi.identity.col.dimension': '维度',
  'pages.openapi.identity.col.beforeWithDevice': '未认证（当前有商业机）',
  'pages.openapi.identity.col.beforeNoDevice': '未认证（当前无商业机）',
  'pages.openapi.identity.col.afterGithub': 'GitHub 认证后',
  'pages.openapi.identity.col.githubDev': 'GitHub（个人开发者）',
  'pages.openapi.identity.col.enterpriseDev': '企业认证（企业开发者）',
  'pages.openapi.identity.row.llmOpenSource': '开源设备大模型',
  'pages.openapi.identity.row.llmAdvanced': '高级 / 视觉模型 · 内测音色',
  'pages.openapi.identity.row.kb': '知识库',
  'pages.openapi.identity.row.openSourceLimit': '开源设备绑定上限',
  'pages.openapi.identity.row.openapi': '开放平台 API Key',
  'pages.openapi.identity.row.customOta': '自定义 OTA',
  'pages.openapi.identity.row.enterpriseOps': '企业产线 / License 管理',
  'pages.openapi.identity.row.position': '定位',
  'pages.openapi.identity.row.precondition': '前置条件',
  'pages.openapi.identity.row.openapiTier': 'OpenAPI 档位',
  'pages.openapi.identity.row.tenantLogo': '企业管理 / Logo',
  'pages.openapi.identity.row.license': '商业 License 录入',
  'pages.openapi.identity.row.production': '产线 Token / 企业固件 OTA',
  'pages.openapi.identity.row.tenantScopes': 'tenants:* / 产线相关 scope',
  'pages.openapi.identity.row.kbLimit': '知识库上限',
  'pages.openapi.identity.val.openSourceLogic': '现有开源模型配置',
  'pages.openapi.identity.val.sameOpenSource': '同左（开源机仍不能绑商业 LLM）',
  'pages.openapi.identity.val.commercialDeviceOk': '商业机可用（按 License）',
  'pages.openapi.identity.val.kb2': '上限 2（仅自绑商业机）',
  'pages.openapi.identity.val.kb0': '不可用（需先绑商业授权设备）',
  'pages.openapi.identity.val.kb5': '上限 5（仍仅自绑商业机；无商业机仍为 0）',
  'pages.openapi.identity.val.openapiOff': '默认不开通',
  'pages.openapi.identity.val.openapiL1': '开通 · 默认 L1 体验档',
  'pages.openapi.identity.val.needEnterprise': '—（需企业认证）',
  'pages.openapi.identity.val.personalDev': '个人 / 开源向开发者',
  'pages.openapi.identity.val.b2bDev': 'B2B：租户、产线、授权',
  'pages.openapi.identity.val.needGithub': '登录 + 绑定 GitHub',
  'pages.openapi.identity.val.loginOnly': '仅需登录即可申请（不要求先 GitHub）',
  'pages.openapi.identity.val.l4l5': '默认 L4 / L5（商业 / 企业档）',
  'pages.openapi.identity.val.highTierScopes': '✅（高档套餐）',
  'pages.openapi.identity.val.kb5short': '有商业机时 5',
  'pages.openapi.identity.val.kbContract': '合同值（建议默认 10）；仍仅本账号自绑商业机，非企业共享库',

  'pages.openapi.status.active': '启用',
  'pages.openapi.status.disabled': '禁用',

  'pages.openapi.apps.title': '应用与密钥',
  'pages.openapi.apps.listTitle': '我的应用',
  'pages.openapi.apps.create': '创建应用',
  'pages.openapi.apps.createModal': '创建应用',
  'pages.openapi.apps.name': '应用名称',
  'pages.openapi.apps.nameRequired': '请输入名称',
  'pages.openapi.apps.description': '描述',
  'pages.openapi.apps.status': '状态',
  'pages.openapi.apps.createdAt': '创建时间',
  'pages.openapi.apps.createSuccess': '应用已创建',
  'pages.openapi.apps.createFailed': '创建失败',
  'pages.openapi.apps.loadFailed': '加载应用失败',
  'pages.openapi.apps.keysLoadFailed': '加载密钥失败',
  'pages.openapi.apps.delete': '删除',
  'pages.openapi.apps.deleteConfirm': '确定删除该应用？',
  'pages.openapi.apps.deleted': '已删除',
  'pages.openapi.apps.createKey': '创建 Key',
  'pages.openapi.apps.createKeyModal': '创建 API Key',
  'pages.openapi.apps.keyCreateSuccess': '密钥已创建',
  'pages.openapi.apps.keyCreateFailed': '创建密钥失败',
  'pages.openapi.apps.noPlainKey': '未返回明文密钥',
  'pages.openapi.apps.plainKeyTitle': '请妥善保存 API Key',
  'pages.openapi.apps.plainKeyHint': '明文仅展示一次，关闭后无法再次查看。',
  'pages.openapi.apps.copy': '复制',
  'pages.openapi.apps.copied': '已复制',
  'pages.openapi.apps.copyFailed': '复制失败，请手动选择',
  'pages.openapi.apps.close': '关闭',
  'pages.openapi.apps.key.name': '名称',
  'pages.openapi.apps.key.namePlaceholder': '生产主 Key',
  'pages.openapi.apps.key.scopes': '权限（scopes）',
  'pages.openapi.apps.key.applyKioskTemplate': '应用展厅模板',
  'pages.openapi.apps.key.scopesHint':
    '默认勾选「展厅三件套」（指标/天气/绑定智能体）。平台新增设备侧接口后，存量 Key 不会自动获得新权限：请到管理端「开放平台 → 应用 → Key 详情」补勾，或新建带新模板的 Key。',
  'pages.openapi.apps.key.prefix': '前缀',
  'pages.openapi.apps.key.env': '环境',
  'pages.openapi.apps.key.status': '状态',
  'pages.openapi.apps.key.createdAt': '创建时间',
  'pages.openapi.apps.key.disable': '禁用',
  'pages.openapi.apps.key.disableConfirm': '确定禁用该密钥？',
  'pages.openapi.apps.key.disabled': '已禁用',
  'pages.openapi.apps.key.enable': '启用',
  'pages.openapi.apps.key.enableConfirm': '确定启用该密钥？',
  'pages.openapi.apps.key.enabled': '已启用',
  'pages.openapi.apps.key.rotate': '轮换',
  'pages.openapi.apps.key.rotateConfirm': '轮换将生成新密钥并返回明文一次，确定？',
  'pages.openapi.apps.key.rotated': '已轮换',
  'pages.openapi.apps.key.delete': '删除',
  'pages.openapi.apps.key.deleteConfirm': '确定删除该密钥？不可恢复',
  'pages.openapi.apps.key.deleted': '已删除',
  'pages.openapi.apps.webhook': 'Webhook',
  'pages.openapi.apps.webhookConfig': 'Webhook',
  'pages.openapi.apps.webhookModal': '配置 Webhook',
  'pages.openapi.apps.webhookSaved': 'Webhook 已保存',
  'pages.openapi.apps.webhookUrl': '回调 URL',
  'pages.openapi.apps.webhookUrlInvalid': '请输入合法 URL',
  'pages.openapi.apps.rotateWebhookSecret': '轮换 webhook_secret',
  'pages.openapi.apps.webhookSecretTitle': '请妥善保存 Webhook Secret',
  'pages.openapi.apps.pageHintTitle': '应用、API Key 与 Webhook',
  'pages.openapi.apps.pageHintDesc':
    '应用用于管理开放平台接入凭证：创建 API Key 后，你的程序可主动调用我们的接口。Webhook（可选）则相反——支付成功、设备首次激活、音色克隆完成时，平台会主动通知你配置的网址，便于你的后台自动加额度、同步订单或提示用户，无需反复轮询。只在控制台操作、没有自建业务系统时，可以不配置 Webhook。企业代操作（partner:act-as）的外部用户映射按「应用」隔离：同一应用下不同 Key 共用同一外部用户；不同应用即使外部用户 ID 相同也是独立影子用户。',
  'pages.openapi.apps.webhookWhatTitle': 'Webhook 是干什么的？',
  'pages.openapi.apps.webhookWhatDesc':
    '平台在业务事件发生时，主动 POST 到你填写的网址（类似“快递到了给你打电话”），让你的服务器自动处理，而不必你不停查询接口。',
  'pages.openapi.apps.webhookEventOrder':
    '订单支付成功（order.paid）：自动加额度、改订单状态、发通知',
  'pages.openapi.apps.webhookEventDevice':
    '设备首次激活（device.activated）：同步 CRM/ERP、经销商记账',
  'pages.openapi.apps.webhookEventClone':
    '音色克隆完成（voice_clone.completed）：App/小程序提示用户可用',
  'pages.openapi.apps.webhookOptionalHint':
    '没有自建后台对接这些自动化时，可留空。URL 与 Secret 都配齐后才会推送。',
  'pages.openapi.apps.webhookUrlExtra':
    '须为公网可访问的 HTTPS 地址；本地调试需内网穿透。清空并保存即关闭推送。',
  'pages.openapi.apps.rotateWebhookSecretExtra':
    'Secret 用于校验回调签名，防止伪造通知；轮换后旧 Secret 立即失效，明文仅展示一次。',
  'pages.openapi.apps.rotateNo': '否',
  'pages.openapi.apps.rotateYes': '是（将返回新 secret，仅一次）',
  'pages.openapi.apps.webhookSecretHint':
    '明文仅展示一次。请保存在你的服务器配置中，用于校验平台回调签名。',

  'pages.openapi.logs.title': '调用记录',
  'pages.openapi.logs.listTitle': '调用明细',
  'pages.openapi.logs.dailyTitle': '近 14 日用量',
  'pages.openapi.logs.dailyEmpty': '暂无日用量数据',
  'pages.openapi.logs.date': '日期',
  'pages.openapi.logs.count': '调用次数',
  'pages.openapi.logs.createdAt': '时间',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': '粘贴接口返回的 request_id',
  'pages.openapi.logs.detail': '详情',
  'pages.openapi.logs.detailTitle': '调用详情',
  'pages.openapi.logs.detailLoading': '加载中…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': '入参',
  'pages.openapi.logs.responseBody': '响应',
  'pages.openapi.logs.app': '应用',
  'pages.openapi.logs.appId': '应用 ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': '用户 ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key 前缀',
  'pages.openapi.logs.method': '方法',
  'pages.openapi.logs.path': '路径',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': '业务码',
  'pages.openapi.logs.latency': '耗时(ms)',
  'pages.openapi.logs.loadFailed': '加载失败',

  'pages.openapi.planTiers.title': '开放平台套餐配置',
  'pages.openapi.planTiers.level': '等级',
  'pages.openapi.planTiers.levelTip': '套餐档位等级（1–5），与用户资料中的 Level 对齐，数字越大档位越高。',
  'pages.openapi.planTiers.name': '名称',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    '每秒请求数上限（Queries Per Second）。作为该档位 API Key 调用的默认限流：稳态速率为该值，突发容量约为 QPS×2（至少 5）。仅约束 API Key 调用；控制台/管理端不计。单个 Key 可另行覆盖。超限返回 HTTP 429（业务码 42901）。',
  'pages.openapi.planTiers.dailyQuota': '日配额',
  'pages.openapi.planTiers.dailyQuotaTip':
    '每个自然日允许的 API 请求总数上限。按用户/Key 维度计数，仅 API Key 调用计入。单个 Key 可另行覆盖。超限返回 HTTP 429（业务码 42902）。',
  'pages.openapi.planTiers.maxApps': '应用数上限',
  'pages.openapi.planTiers.maxAppsTip': '该档位开发者最多可创建的开放平台应用数量。',
  'pages.openapi.planTiers.maxKeys': '每应用 Key 上限',
  'pages.openapi.planTiers.maxKeysTip': '每个应用下最多可创建的 API Key 数量。',
  'pages.openapi.planTiers.allowedScopes': '允许权限（scopes）',
  'pages.openapi.planTiers.allowedScopesTip':
    '该档位允许申请/授予的接口权限范围。应用与 API Key 的实际权限为此处勾选集合的子集。',
  'pages.openapi.planTiers.save': '保存',
  'pages.openapi.planTiers.saved': '已保存',
  'pages.openapi.planTiers.saveFailed': '保存失败',
  'pages.openapi.planTiers.loadFailed': '加载套餐失败',
  'pages.openapi.planTiers.readonly': '观察员只读，无法修改套餐档位',

  'pages.openapi.scope.agentsRead': '智能体 · 读取',
  'pages.openapi.scope.agentsWrite': '智能体 · 写入',
  'pages.openapi.scope.devicesRead': '设备 · 读取',
  'pages.openapi.scope.devicesWrite': '设备 · 写入',
  'pages.openapi.scope.devicesMetricsRead': '设备指标 · 读取（亲密度/活力）',
  'pages.openapi.scope.devicesWeatherRead': '设备天气 · 读取',
  'pages.openapi.scope.devicesAgentRead': '设备绑定智能体 · 读取',
  'pages.openapi.scope.chatsRead': '对话记录 · 读取',
  'pages.openapi.scope.voicesRead': '音色/克隆 · 读取',
  'pages.openapi.scope.voicesWrite': '音色/克隆 · 写入',
  'pages.openapi.scope.kbRead': '知识库 · 读取',
  'pages.openapi.scope.kbWrite': '知识库 · 写入',
  'pages.openapi.scope.ordersRead': '订单 · 读取',
  'pages.openapi.scope.ordersWrite': '订单 · 写入',
  'pages.openapi.scope.statsRead': '用量统计 · 读取',
  'pages.openapi.scope.todosRead': '待办 · 读取',
  'pages.openapi.scope.todosWrite': '待办 · 写入',
  'pages.openapi.scope.tenantsRead': '企业租户 · 读取',
  'pages.openapi.scope.tenantsWrite': '企业租户 · 写入',
  'pages.openapi.scope.productionWrite': '产线签发 · 写入',
  'pages.openapi.scope.adminWrite': '平台管理 · 写入',
  'pages.openapi.scope.partnerActAs': '企业代操作 · 外部用户上下文',

  'pages.openapi.usersUsage.title': '开放平台用户限额与今日用量',
  'pages.openapi.usersUsage.userId': '用户 ID',
  'pages.openapi.usersUsage.username': '用户名',
  'pages.openapi.usersUsage.level': '等级',
  'pages.openapi.usersUsage.developerEnabled': '开通状态',
  'pages.openapi.usersUsage.plan': '套餐',
  'pages.openapi.usersUsage.rateLimitQps': 'QPS 上限',
  'pages.openapi.usersUsage.dailyQuota': '日配额',
  'pages.openapi.usersUsage.todayUsed': '今日已用',
  'pages.openapi.usersUsage.loadFailed': '加载失败',

  'pages.openapi.admin.usageLogsTitle': '开放平台调用审计',
  'pages.openapi.admin.usageLogsList': '全局调用记录',
  'pages.openapi.admin.disableKeyConfirm': '确定禁用该 API Key？',
  'pages.openapi.admin.disableKey': '禁用 Key',
  'pages.openapi.admin.keyDisabled': '已禁用',
  'pages.openapi.admin.appsTitle': '开放平台应用管理',
  'pages.openapi.admin.appsList': '全部开发者应用',
  'pages.openapi.admin.developers': '开发者',
  'pages.openapi.admin.apps': '应用',
  'pages.openapi.admin.keys': 'Key 总数',
  'pages.openapi.admin.activeKeys': '启用 Key',
  'pages.openapi.admin.todayRequests': '今日调用',
  'pages.openapi.admin.todayErrors': '今日错误',
  'pages.openapi.admin.errorCount': '错误次数',
  'pages.openapi.admin.owner': '属主',
  'pages.openapi.admin.keyCount': 'Key 数',
  'pages.openapi.admin.keyword': '关键词',
  'pages.openapi.admin.keywordPlaceholder': '应用名 / 描述 / 租户编码',
  'pages.openapi.admin.statsLoadFailed': '加载统计失败',
  'pages.openapi.admin.noKeys': '暂无密钥',
  'pages.openapi.admin.appEnabled': '应用已启用',
  'pages.openapi.admin.appDisabled': '应用已禁用',
  'pages.openapi.admin.appDisableConfirm': '确定禁用该应用？',
  'pages.openapi.admin.appEnableConfirm': '确定启用该应用？',
  'pages.openapi.admin.keyEnableConfirm': '确定启用该密钥？',

  'pages.openapi.key.detailTitle': 'Key 详情',
  'pages.openapi.key.scopes': '配置权限',
  'pages.openapi.key.effectiveScopes': '有效权限',
  'pages.openapi.key.saveScopes': '保存权限',
  'pages.openapi.key.scopesSaved': '权限已保存',
  'pages.openapi.key.scopesSaveFailed': '保存权限失败',
  'pages.openapi.key.noAllowedScopes':
    '属主套餐未配置 allowed_scopes，无法勾选/保存。请先在套餐档位中维护可授权范围。',
  'pages.openapi.key.selectAllAllowed': '全选套餐权限',
  'pages.openapi.key.clearScopes': '清空',
  'pages.openapi.key.outOfPlanHint':
    '该 Key 另有 {count} 项已不在当前套餐范围内的权限，界面不展示；保存后将按勾选结果全量覆盖并移除超范围项。',
  'pages.openapi.key.scopesHint':
    '仅展示并允许勾选属主当前套餐 allowed_scopes 内的权限；管理员可对任意 Key 补权/收权，保存后全量覆盖并立即生效。',

  'pages.admin.user.openapiDeveloperEnabled': '开放平台',
  'pages.admin.user.openapi.on': '已开通',
  'pages.admin.user.openapi.off': '未开通',
  'pages.admin.user.openapiLevel': '开放平台等级',
  'pages.admin.user.openapiDeveloperEnabled.label': '开通开发者',
  'pages.admin.user.openapiLevel.label': '等级',
  'pages.admin.user.openapiLevel.placeholder': '1-5',

  'pages.openapi.partner.adminTitle': '企业外部用户映射',
  'pages.openapi.partner.adminList': '映射列表',
  'pages.openapi.partner.externalUserId': '外部用户 ID',
  'pages.openapi.partner.externalUserIdPlaceholder': '支持模糊搜索',
  'pages.openapi.partner.userId': '影子用户 ID',
  'pages.openapi.partner.appId': '应用 ID',
  'pages.openapi.partner.app': '应用',
  'pages.openapi.partner.appNamePlaceholder': '应用名称（模糊）',
  'pages.openapi.partner.ownerPlaceholder': '属主用户名（模糊）',
  'pages.openapi.partner.shadowUser': '影子用户',
  'pages.openapi.partner.userDisabled': '影子用户已禁用',
  'pages.openapi.partner.tenantCode': '租户编码',
  'pages.openapi.partner.displayName': '显示名',
  'pages.openapi.partner.displayNamePlaceholder': '映射显示名（模糊）',
  'pages.openapi.partner.disableConfirm': '确定禁用该映射？将同步禁用影子用户，代操作将返回 403',
  'pages.openapi.partner.enableConfirm': '确定启用该映射？',
  'pages.openapi.partner.disabled': '已禁用',
  'pages.openapi.partner.enabled': '已启用',
  'pages.openapi.partner.drawerTitle': '外部用户映射',
  'pages.openapi.partner.openLinks': '外部用户',
  'pages.openapi.partner.scopeHintTitle': '映射范围：按「应用」隔离，不是按企业账号共用',
  'pages.openapi.partner.scopeHintDesc':
    '外部用户映射主键为「应用 + 外部用户 ID」。同一应用下不同 API Key、相同外部用户 ID，对应同一影子用户与资源；同一企业账号下的不同应用，即使外部用户 ID 相同，也是各自独立的影子用户，设备与智能体互不共享。',
  'pages.openapi.partner.drawerScopeHintDesc':
    '本列表仅为当前应用的外部用户映射。同一应用下任意 API Key、相同外部用户 ID，对应同一影子用户；其它应用下的同名外部 ID 不会出现在此，也不会共享设备与智能体。',
};
